import React, { useCallback } from 'react';
import classNames from 'classnames';
import { AvatarWithInitials } from 'components/AvatarWithInitials';
import { SIZE } from 'models/Size';
import usePastTime from 'hooks/usePastTime';
import { getSellingPortfolio, getUserFullNameOrEmail } from 'utils';
import NotificationMediumTag from 'components/NotificationMediumTag';
import { LeadNotification } from 'models/LeadNotifications';
import { useNavigate } from 'react-router-dom';
import useLeadNotificationCopy from 'hooks/useLeadNotificationCopy';
import NotificationStatusTag from 'components/NotificationStatusTag';

import './LeadNotificationCard.styles.scss';

type LeadNotificationCardProps = {
  className?: string;
  notification: LeadNotification;
  onDealClick?: () => void;
};

const LeadNotificationCard: React.FC<LeadNotificationCardProps> = (props) => {
  const { className, notification, onDealClick } = props;

  const { typeCode, channel, user, dealRoom, createdAt, status } =
    notification || {};

  const classes = classNames('lead-notification-card', className);

  const time = usePastTime()(createdAt);

  const getCopy = useLeadNotificationCopy();

  const navigate = useNavigate();

  const navigateToDeal = useCallback(() => {
    onDealClick?.();
    navigate(getSellingPortfolio(dealRoom?._id));
  }, [dealRoom?._id, navigate, onDealClick]);

  return (
    <div className={classes}>
      <div className="lead-notification-card__avatar">
        <AvatarWithInitials user={user} size={SIZE.BIG} />
      </div>

      <div className="lead-notification-card__content">
        <div className="lead-notification-card__content__main-info">
          <p className="name">{getUserFullNameOrEmail(user)}</p>

          <p className="deal clickable" onClick={navigateToDeal}>
            {dealRoom?.name}
          </p>
        </div>

        <div className="lead-notification-card__content__heading">
          <p className="lead-notification-card__content__heading__text">
            {getCopy(typeCode, status, user)}
          </p>
        </div>

        <div className="lead-notification-card__content__actions">
          <NotificationStatusTag status={status} />
          <NotificationMediumTag type={channel} />
          <p className="time">{time}</p>
        </div>
      </div>
    </div>
  );
};

export default LeadNotificationCard;
